import type { CookieT } from '~/types/cookie'

export const useUTMStore = defineStore('utm', () => {
  const config = useRuntimeConfig()
  const utmState = useCookie<CookieT>(config.public.attribution_cookie_key)

  const getUtmState = computed(() => utmState.value)

  const setUtmState = (newCookie: Partial<CookieT>) => {
    utmState.value = {
      ...utmState.value,
      ...newCookie
    }
  }

  return {
    utmState,
    getUtmState,
    setUtmState
  }
})
